export default {
  openDialog(state) {
    state.isDialogDisplayed = true;
  },
  closeDialog(state) {
    state.isDialogDisplayed = false;
  },
};
